<template>
  <el-dialog
    :title="$t('widgets_basic_banner_index_439')"
    :visible.sync="isShow"
    class="atlas_edit_img"
    width="600"
    append-to-body
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="closed"
    v-loading="get_loading"
  >
    <div class="atlas_edit_img_frame">
      <div class="atlas_edit_swiper_frame">
        <swiper ref="mySwiper" class="atlas_edit_swiper" :options="swiperOption">
          <swiper-slide v-for="(item,i) in list" :key="i">
            <div class="one_img">
              <img :src="item.img_path" />
              <i class="edit img_viewer_edit" @click.stop="img_change(item)"></i>
            </div>
          </swiper-slide>
          <div class="swiper-button-prev" slot="button-prev"></div>
          <div class="swiper-button-next" slot="button-next"></div>
        </swiper>
      </div>

      <div class="img_edit_content">
        <my_link
          :value.sync="list[img_i].intro.select_val_preview"
          width="185"
          :title="$t('components_atlas_edit_img_index_1998')"
          titleWidth="70"
          :link="list[img_i].intro"
        ></my_link>
        <my_input
          titleWidth="70"
          :title="$t('components_atlas_edit_img_index_1999')"
          :placeholder="$t('widgets_basic_banner_edit_435')"
          :value.sync="list[img_i].img_name"
          type="one_level"
          width="275"
        ></my_input>
        <my_input
          titleWidth="70"
          :title="$t('widgets_basic_banner_edit_437')"
          :placeholder="$t('widgets_basic_banner_edit_435')"
          :value.sync="list[img_i].summary"
          type="one_level"
          width="275"
        ></my_input>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="img_edit_sure">{{$t('view_public_topbar_15')}}</el-button>
      <el-button @click="closed">{{$t('view_public_topbar_14')}}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import i18n from '../../language/index'

import { editAtlasList } from "@/api/app.js";
export default {
  name: "atlas_edit_img",
  data() {
    return {
      isShow: true,
      get_loading: false,
      swiperOption: {
        myVm: this,
        loop: false,
        direction: "horizontal",
        effect: "fade",
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        on: {
          slideChange: function(e) {
            const that = this.passedParams.myVm;
            that.img_i = this.activeIndex;
          },
          init: function() {
            const that = this.passedParams.myVm;
            that.$nextTick(() => {
              that.$refs.mySwiper.swiper.slideTo(that.img_i, 0, false);
            });
          }
        }
      },
      atlas: null,
      list: JSON.parse(JSON.stringify(this.imgs)),
      img_i: this.img_index
    };
  },
  props: {
    img_index: {
      type: Number,
      default: 0
    },
    imgs: {
      type: Array,
      default: []
    }
  },
  methods: {
    closed() {
      this.$emit("closed");
    },
    img_edit_sure() {
      this.$emit("img_edit_sure", this.list);
      this.$emit("closed");
    },
    img_change(item) {
      this.$store.commit("image_upload/set_fileType", 1);
      this.$store.commit("image_upload/set_showTag", true);
      this.$store.commit("image_upload/set_fileLimit", 1);
      this.$store.state.image_upload.imgFile = e => {
        if (e && e instanceof Array && e.length > 0) {
          item.img_path = e[0].filePath;
        }

        this.$store.state.image_upload.imgFile = null;
      };
    }
  },
  computed: {},
  components: {},
  created() {},
  mounted() {
    console.log("图片集合", this.list);
  }
};
</script>

<style scoped lang="scss">
.atlas_edit_img {
  /deep/ .el-dialog__header {
    border: 1px solid #e3e2e8;
  }
  /deep/ .el-dialog__footer {
    .dialog-footer {
      text-align: center;
      .el-button {
        margin: 8px 18px;
        padding: 0 28px;
        height: 34px;
      }
    }
  }
}
.atlas_edit_img {
  /deep/ .el-dialog {
    width: 470px;

    .atlas_edit_swiper_frame {
      height: 155px;

      .atlas_edit_swiper {
        height: 100%;

        .one_img {
          width: 216px;
          height: 100%;
          border: 1px solid #eee;
          position: relative;
          vertical-align: middle;
          text-align: center;
          margin: 0 auto;
          background: #fff;

          img {
            max-width: 100%;
            max-height: 100%;
            position: absolute;
            top: 0;
            left: 0;
            bottom: 0;
            right: 0;
            margin: auto;
          }
        }
        .one_img:hover .img_viewer_edit {
          display: block;
        }
      }
    }

    .img_edit_content {
      padding-left: 27px;
      margin-top: 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/atlas_edit_img/index.vue